exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-bg-color[data-v-f2a063f6]{background-color:#f5f4e8\n}\n", ""]);

// exports
